// extracted by mini-css-extract-plugin
export default {"div":"Cart_div__PfGmd","nav-cart--notification-custom":"Cart_nav-cart--notification-custom__d7+SN"};